module.exports = __webpack_public_path__ + "img/upload-green.c42452a2.svg";